/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type FC, useEffect, useMemo } from 'react';
import { styled } from '@compiled/react';
import { virtualAgentCreateIntentTemplateSidebarEntryPoint } from '@jira/servicedesk__virtual-agent-create-intent-templates-sidebar/src/virtualAgentCreateIntentTemplateSidebarEntryPoint.entrypoint.tsx';
import { ErrorDisplay } from '@jira/servicedesk__virtual-agent-create-intent-templates-sidebar/src/ErrorDisplay.tsx';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { useActiveRightSidebarState } from '@jira/platform__controllers-layout/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { VirtualAgentIntentTemplateSidebarSkeleton } from '@jira/platform__skeletons/src/ui/virtual-agent/intent-template-sidebar/VirtualAgentIntentTemplateSidebarSkeleton.tsx';
import { token } from '@atlaskit/tokens';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const runtimeProps = {};
export const IntentTemplatesSidebar: FC = () => {
	const rightSidebarCurrentState = useActiveRightSidebarState();
	const panelId = rightSidebarCurrentState?.panelId ?? '';
	const cloudId = useCloudId();
	const { data: projectContextData } = useProjectContext();

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			key: projectContextData?.projectKey ?? '',
			isHideIntentDiscoveryWhenVaNotConfiguredEnabled: fg(
				'hide_intent_discovery_copy_when_va_not_configured',
			),
		}),
		[cloudId, projectContextData],
	);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		virtualAgentCreateIntentTemplateSidebarEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (panelId === 'intentTemplate') {
			entryPointActions.load();
		} else {
			entryPointActions.unload();
		}
	}, [entryPointActions, panelId]);

	return (
		<JiraEntryPointContainer
			id="createIntentTemplatesSidebar"
			packageName="jiraServicedeskSettingsVirtualAgentCreateIntentTemplates"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<VirtualAgentIntentTemplateSidebarSkeleton />}
			errorFallback={() => (
				<SideBarWrapper>
					{/* aks my rules */}
					{/* eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage */}
					<ErrorDisplay refetch={() => window.location.reload()} />
				</SideBarWrapper>
			)}
			runtimeProps={runtimeProps}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const SideBarWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',

	borderLeft: `${token('border.width.selected')} solid ${token('color.border')}`,

	backgroundColor: token('elevation.surface.overlay'),
	boxSizing: 'border-box',
	rowGap: token('space.100'),
	height: '100%',
	overflowY: 'auto',
});

export default IntentTemplatesSidebar;
